export const WORKFLOW_NUDGE_ID = 'workflowNudge';
